import { CACHE_VERSION } from './cacheVersion';

// 字典会话缓存：模块级 Map + sessionStorage 双层，TTL 420s，键含 CACHE_VERSION 与业务参数。
// 同 key 在途请求合并（pending 队列）：冷启动首个调用发请求并挂起，同 key 后续调用入队，响应后统一分发。
// 失败路径：loader 未回调成功时队列悬挂，悬挂超过 PENDING_TIMEOUT（15s）自动清队，下次调用重新发起——
// 与原生请求失败表现一致（doneResult 不执行、AjaxRequest 自带告警），且不会永久污染会话。
// sessionStorage 读写均 try/catch：损坏或配额异常时退化为仅模块级 Map。
//
// 用法（缓存数据为接口完整响应，调用方在 doneResult 中自行取字段）：
//   dictCache.getDict('LINE_OF_BUSINESS', cb => {
//       $.sendRequest({ ..., doneResult: res => cb(res) });
//   }, res => this.setState({ businessList: res.typeConfigureList || [] }));
//
// 带参字典的 key 必须拼接参数，如 `REMITTANCE_DICT_Expense_Type`、`CONFIG_WITH_CHILD_FTEQuoteRule`。
const CACHE_TTL = 420 * 1000;
// 悬挂队列自愈时限：loader 超时未回调成功视为失败，清队后下次调用重新发起
const PENDING_TIMEOUT = 15 * 1000;
const memCache = new Map();
const pending = new Map();

const storageKey = key => `dict_${CACHE_VERSION}_${key}`;

const readStore = key => {
    try {
        return JSON.parse(sessionStorage.getItem(storageKey(key)) || 'null');
    } catch (e) {
        return null;
    }
};

const writeStore = (key, entry) => {
    try {
        sessionStorage.setItem(storageKey(key), JSON.stringify(entry));
    } catch (e) {
        // 配额/隐私模式异常时退化为仅内存缓存
    }
};

const getDict = (key, loader, doneResult) => {
    const hit = memCache.get(key) || readStore(key);
    if (hit && Date.now() - hit.ts < CACHE_TTL) {
        memCache.set(key, hit);
        doneResult(hit.data);
        return;
    }
    const hanging = pending.get(key);
    if (hanging && Date.now() - hanging.ts < PENDING_TIMEOUT) {
        hanging.cbs.push(doneResult);
        return;
    }
    // 无悬挂队列或悬挂超时（上次请求失败）：清队重新发起
    pending.set(key, { cbs: [doneResult], ts: Date.now() });
    loader(data => {
        const entry = { ts: Date.now(), data };
        memCache.set(key, entry);
        writeStore(key, entry);
        const cbs = (pending.get(key) || {}).cbs || [];
        pending.delete(key);
        cbs.forEach(cb => cb(data));
    });
};

const dictCache = { getDict };

export { dictCache };
export default dictCache;



// WEBPACK FOOTER //
// ./src/common/dictCache.js